import React from 'react';

import Item from './item';

export default function AssetItem({ filename, ...props }) {
  return (
    <Item {...props} title={filename}>
      {filename}
    </Item>
  );
}

AssetItem.propTypes = {
  filename: React.PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/asset-library/item-asset.jsx